'use client';

import { ReactNode } from 'react';
import { cn } from '@utils/cn';

interface RightSidebarProps {
  /** Content to display in the sidebar */
  children?: ReactNode;
  /** Additional CSS classes */
  className?: string;
}

/**
 * @description Generic right sidebar component for future features.
 * Can be used with TwoColumnLayout to display optional content on the right side.
 */
export const RightSidebar = (props: RightSidebarProps) => {
  const { children, className } = props;

  return (
    <div className={cn('flex h-full flex-col bg-surface-100', className)}>
      <div className="scrollbar-hide h-full overflow-y-auto p-4">
        {children}
      </div>
    </div>
  );
};
